import React, { useState, useMemo, useCallback } from "react";
import { Combobox, Option } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import "./CSS/SearchAgent.css";
export default function SearchAgent({
  agents = [],
  selectedIds = [],
  defaultValue = "",
  onSelect,
}) {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState(defaultValue);

  // ✅ Filter agents dynamically and safely
  const filteredAgents = useMemo(() => {
    const search = searchValue.trim().toLowerCase();
    return agents.filter(
      (a) =>
        a.displayName?.toLowerCase().includes(search) &&
        !selectedIds.includes(a.id)
    );
  }, [agents, selectedIds, searchValue]);

  // ✅ Handle text input change
  const handleChange = useCallback((event) => {
    setSearchValue(event.target?.value || "");
  }, []);

  // ✅ Handle option selection
  const handleSelect = useCallback(
    (_, data) => {
      const selectedId = data.optionValue;
      const agent = agents.find((a) => a.id === selectedId);
      if (agent && onSelect) {
        // Slight delay to let combobox close smoothly
        setTimeout(() => onSelect(agent), 0);
        setSearchValue("");
      }
    },
    [agents, onSelect]
  );

  return (
    <Combobox
      className="search-agent-dropdown-inline"
      placeholder={t("SEARCH_AGENT")}
      value={searchValue}
      onChange={handleChange}
      onOptionSelect={handleSelect}
      appearance="outline"
      style={{ width: "100%" }}
    >
      {filteredAgents.length > 0 ? (
        filteredAgents.map((agent) => (
          <Option key={agent.id} value={agent.id}>
            {agent.displayName || t("UNKNOWN_AGENT")}
          </Option>
        ))
      ) : (
        <Option disabled key="no-results" value="no-results">
          {t("NO_RESULTS_FOUND")}
        </Option>
      )}
    </Combobox>
  );
}
